import { Extension } from '@tiptap/core';
import { debounce } from 'lodash';

export interface DistractionFreeExtensionOptions {
  onDistractionFreeStateChange: (state: boolean) => void;
}
interface DistractionFreeExtensionStorage {
  isDistractionFree: boolean;
  distractionFreeOffHandler: () => void;
}

export const DistractionFreeExtension = Extension.create<
  DistractionFreeExtensionOptions,
  DistractionFreeExtensionStorage
>({
  name: 'distraction-free',

  addOptions() {
    return {
      onDistractionFreeStateChange: () => {},
    };
  },

  addStorage() {
    return {
      isDistractionFree: false,
      distractionFreeOffHandler: () => {},
    };
  },

  onCreate() {
    const enableDistractionFree = debounce(
      () => {
        if (this.editor.isFocused) {
          this.storage.isDistractionFree = true;
          this.options.onDistractionFreeStateChange(true);
        }
      },
      1000,
      {
        leading: true,
      },
    );

    this.storage.distractionFreeOffHandler = (() => {
      enableDistractionFree.cancel();
      if (this.storage.isDistractionFree) {
        this.storage.isDistractionFree = false;
        this.options.onDistractionFreeStateChange(false);
      }
    }).bind(this);
    this.editor.on('update', ({ transaction }) => {
      if (!this.storage.isDistractionFree && transaction.docChanged) {
        enableDistractionFree();
      }
    });

    document.addEventListener(
      'mousemove',
      this.storage.distractionFreeOffHandler,
    );
    this.editor.on('blur', this.storage.distractionFreeOffHandler);
  },

  onDestroy() {
    document.removeEventListener(
      'mousemove',
      this.storage.distractionFreeOffHandler,
    );
    this.editor.off('blur', this.storage.distractionFreeOffHandler);
  },
});
